import { Theme } from '../base-theme';

export const defaultTheme: Theme = {
  name: 'default',
  colors: {
    primary: '#FFF',
    primaryForeground: '#000000',

    secondary: '#161616',
    secondaryForeground: '#FFF',

    accent: '#7DEF8F',
    accentForeground: '#000000',

    destructive: '#EF4444',
    destructiveForeground: '#FFFFFF',
    background: '#0A0A0A',
    foreground: '#FFF',
    mutedForeground: '#545454',
    border: '#232323',
    ring: '#7DEF8F',
  },
  radius: '8px',
  cssVars: {
    '--primary': '0 0% 100%',
    '--primary-foreground': '0 0% 0%',
    '--secondary': '0 0% 9%',
    '--secondary-foreground': '0 0% 100%',
    '--accent': '128 80% 70%',
    '--accent-foreground': '0 0% 0%',
    '--destructive': '0 84% 60%',
    '--destructive-foreground': '0 0% 100%',
    '--background': '0 0% 4%',
    '--foreground': '0 0% 100%',
    '--border': '0 0% 14%',
    '--ring': '128 65% 60%',
    '--muted': '0 0% 33%',
    '--muted-foreground': '0 0% 33%',
    '--radius': '8px',
  },
};
